/**
 * BreadcrumbJsonLd — emits BreadcrumbList JSON-LD schema for inner pages.
 *
 * Unlocks rich-snippet eligibility in Google SERPs. The shadcn Breadcrumb
 * component renders the visual trail; this component handles the machine-
 * readable version. They're decoupled on purpose — pages that don't need a
 * visible breadcrumb (e.g. /water-budget with its own hero) can still emit
 * the schema.
 *
 * Usage:
 *   <BreadcrumbJsonLd items={[
 *     { label: 'Home', path: '/' },
 *     { label: 'Water Budget', path: '/water-budget' },
 *   ]} />
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://getturfpulse.com';

export const BreadcrumbJsonLd = ({ items }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.label,
      item: `${SITE_URL}${item.path}`,
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default BreadcrumbJsonLd;
